/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { GetFolderPath, GetFolderSuccess } from './configuration-location-actions';
import { concatMap, map } from 'rxjs/operators';
import { DataInitializerService } from '../../../../../utils/src';
import { ConfigurationLocationPathPicker, ConfigurationLocationPathPickerObject } from '../../models/configuration-location-return-codes';

@Injectable()
export class ConfigurationLocationEffects {
  constructor(private readonly actions$: Actions, private dataInitializerService: DataInitializerService) {}

  GetFolderPath$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetFolderPath),
      concatMap(() =>
        this.dataInitializerService.getFolderPath().pipe(
          map((data: ConfigurationLocationPathPicker | ConfigurationLocationPathPickerObject) => {
            if ('path' in data) {
              return GetFolderSuccess({ folderPath: data.path, statusCode: data.returnCode });
            } else if ('result' in data) {
              return GetFolderSuccess({ folderPath: data.result.path, statusCode: data.result.returnCode });
            } else {
              throw new Error('Unexpected response type');
            }
          })
        )
      )
    );
  });
}
